import { NodeDicionarioModel } from '../tipoDoc/nodeDicionario.model';
import { TipoConteudoModel } from './tipoconteudo.model';
export class ConteudoModel {
  id: number;
  rgItem: String;
  descricaoConteudo: String;
  origem: String;
  dataInicial: Date;
  dataFinal: Date;
  tipoConteudo: TipoConteudoModel;
  caixa: any;
  nodeDicionario: NodeDicionarioModel;
  numDocInicial: String;
  numDocFinal: String;
}




// WEBPACK FOOTER //
// /app/src/app/model/caixa/conteudo.model.ts